/**
 * SOLID Review
 * S — Strong. One pure function turning a numeric Meyer score into its display label (Meyer/Little
 *     Meyer/pair/two-digit). 6 lines, single concern.
 * O — Good. A new special-cased score (like 1000/900) is one more early-return line; the general formula
 *     path is untouched.
 * L — N/A — no inheritance hierarchy (plain function).
 * I — N/A — no interface/props surface; a single-argument function.
 * D — Strong. Zero imports — no coupling to any layer.
 */
export function fmtScore(score: number): string {
  if (score === 1000) return 'Meyer';
  if (score === 900)  return 'Little Meyer';
  if (score >= 110)   return `Pair ${(score - 100) / 10}s`;
  return `${Math.floor(score / 10)}-${score % 10}`;
}
